import axios, { AxiosError } from 'axios'
import { escapeRegExp } from '$func/utils'

const SHORTENER_API: string = import.meta.env.VITE_LINK_SHORTNER_API || ''
const SHORTENER_HOST = SHORTENER_API
  ? new URL(SHORTENER_API).host
  : // TODO: Remove wronghost and update URL_SHORTENER_PATTERN
    'u.wronghost.ir'

export const URL_SHORTENER_PATTERN = new RegExp(
  `^(https?:\\/\\/|)${escapeRegExp(SHORTENER_HOST)}/\\w{5,}\\/?$`,
  'gm',
)

export function createShortLink(target: string) {
  if (!SHORTENER_API) return target
  return Promise.race([
    axios
      .post<{ link: string }>(SHORTENER_API, { target })
      .then(res => res.data.link)
      .catch(() => target),

    new Promise<string>(r => setTimeout(r, 5000, target)),
  ])
}

function safeStringify(data: any) {
  try {
    const str = JSON.stringify(data)
    return str
  } catch (e) {
    return null
  }
}

export async function getShortLinkTarget(link: string) {
  try {
    const response = await axios.get<{ target: string }>(`${link}+`)
    return response.data.target
  } catch (e) {
    if (e instanceof AxiosError) {
      analite('INVALID_SHORT_LINK', {
        status: e.response?.status,
        message: e.message,
        data: e.response?.data,
      })
    } else {
      const stringified = safeStringify(e)
      if (stringified)
        analite('INVALID_SHORT_LINK', { errorStringified: stringified, link })
    }
    return null
  }
}
